export default {"src":"/_next/static/media/saas.e60bb235.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};